export const WHATSAPP_NUMBER = "601111251718";
export const CONTACT_NAME = "En Remmy";
export const CONTACT_DISPLAY_PHONE = "011-1125 1718";
export const HERO_BADGE_TEXT = "PENDAFTARAN DIBUKA";
export const COURSE_TITLE = "KURSUS ASAS PENGAWAL PERIBADI";
export const COURSE_DATES = "2, 3 & 4 OKTOBER 2026";
export const COURSE_LOCATION_NAME = "KEM METANG GANA";
export const COURSE_LOCATION_AREA = "SAMPADI, LUNDU";
export const COURSE_FEE = "RM1,100";
export const COURSE_DEPOSIT = "RM500";
export const COURSE_BALANCE = "RM600";
export const COURSE_SEATS = 20;
export const EVENT_DATE = new Date("2026-10-02T00:00:00+08:00");

export const MAPS_QUERY = "Kem Metang Gana, Sampadi, Lundu";
export const MAPS_EMBED_URL = `https://www.google.com/maps?q=${encodeURIComponent(MAPS_QUERY)}&output=embed`;
export const MAPS_SEARCH_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAPS_QUERY)}`;

export function buildWhatsAppUrl(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export const GENERAL_INQUIRY_MESSAGE = `Salam ${CONTACT_NAME}, saya ingin bertanya mengenai ${COURSE_TITLE}.`;
